import { lazy } from 'react';
import { RouteItem } from '../@types/routes';
import i18n from '../i18n';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import RegisterUser from './RegisterUser';

const ServiceUnavailable = lazy(() => import('./ServiceUnavailable'));
const ScheduledWorkplace = lazy(() => import('./ScheduledWorkplace'));
const HazardousWasteOrder = lazy(() => import('./HazardousWasteOrder'));
const AppPromoRedirect = lazy(() => import('./Home/Widgets/AppPromo/AppPromoRedirect'));

export const publicRoutes: RouteItem[] = [
  {
    title: i18n.t('privacypolicy_title'),
    path: '/privacy-policy',
    component: PrivacyPolicy,
    exact: true,
  },
  {
    title: i18n.t('termsofuse_title'),
    path: '/terms-of-use',
    component: TermsOfUse,
    exact: true,
  },
  {
    title: i18n.t('register_user_title'),
    path: '/register-user',
    component: RegisterUser,
    exact: true,
  },
  {
    title: i18n.t('service_unavailable_title'),
    path: '/service-unavailable',
    component: ServiceUnavailable,
    exact: true,
  },
  {
    title: i18n.t('navigation_scheduled_title'),
    path: '/scheduled-workplace/:wp',
    component: ScheduledWorkplace,
    exact: true,
  },
  {
    title: 'Beställ tömning av farligt avfall',
    path: '/hazardous-waste/:container',
    component: HazardousWasteOrder,
    exact: true,
  },
  {
    title: 'app promo redirect',
    path: '/app-promo-redirect',
    component: AppPromoRedirect,
    exact: true,
  },
];
